import useStore from '@/store/useStore'

export const useActiveBroadcast = (broadcastId: string) => {
  const broadcast = useStore((state) => state.common.broadcasts?.[broadcastId])
  const { activeChannel, channelList } = broadcast || {}

  return { activeChannel, channels: channelList }
}
